export enum CustomerForms {
  SignUp = 'customer-sign-up',
}
